var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.163,
    height: 12.195,
    viewBox: "0 0 19.163 12.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#716b7d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.181,16.795,2.6,7.111,5.084,4.6l7.1,7.173,7.1-7.173,2.484,2.511Z",
    transform: "translate(-2.6 -4.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon1);
export default __webpack_public_path__ + "static/media/down-icon-1.6566baa579349c57919188887a006192.svg";
export { ForwardRef as ReactComponent };